// aws-exports.js
const awsconfig = {
    aws_project_region: 'us-east-1',
    aws_cognito_identity_pool_id: 'us-east-1:41b7829c-9959-4950-a618-b222b879a6cf',
    aws_cognito_region: 'us-east-1',
    aws_user_pools_id: 'us-east-1_ljKEGozfk',
    aws_user_pools_web_client_id: '52n4h0b4bersn1hrba0pq0981c',
    aws_rekognition: {
      region: 'us-east-1',
      accessKeyId: 'AKIA3OKBYKMKGRTGJLOD',
      secretAccessKey: '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',
    },
    oauth: {},
    // Include other services if you are using them
  };
  
  export default awsconfig;
  